//  development server url

// export const apiUrl = "http://localhost:5002/api/v1/";
// export const imageBaseUrl = "http://localhost:5002/";

// render server url 

// export const apiUrl = "https://job-inventory-backend.onrender.com/api/v1/";
// export const imageBaseUrl = "https://job-inventory-backend.onrender.com/";

// production server url 

export const apiUrl = "https://api.jinraitech.com/api/v1/";
export const imageBaseUrl = "https://api.jinraitech.com/";


export const getAuthToken = () => {
    try {
        const tokenData = JSON.parse(localStorage.getItem("token"));
        if (tokenData?.token) {
            return `Bearer ${tokenData.token}`;
        }
    } catch (error) {
    }
    return null;
}

export const formateCustomerData = (generalInfo, addresses) => {
    const billingAddress = addresses;
    return {
        // general
        customerName: generalInfo.name || "",
        email: generalInfo.email || "",
        alternativeEmails: generalInfo.alternativeEmails || "",
        telephone: generalInfo.phoneNumber || "",
        gstIn: generalInfo.gstIn || "",
        gstInCode: generalInfo.gstInCode || "",

        // true or false
        isShippingSameAsBilling: billingAddress.isShippingSameAsBilling,

        // billing
        billingAddressOne: billingAddress.address1 || "",
        billingAddressSec: billingAddress.address2 || "",
        billingCity: billingAddress.city || "",
        billingPostalCode: billingAddress.postalCode || "",
        billingState: billingAddress.state || "",
        billingCountry: billingAddress.country,
        billingStateCode: "",

        //shipping
        shippingAddressOne: billingAddress.shippingAddress1 || "",
        shippingAddressSec: billingAddress.shippingAddress2 || "",
        shippingState: billingAddress.shippingState || "",
        shippingCity: billingAddress.shippingCity || "",
        shippingPostalCode: billingAddress.shippingPostalCode || "",
        shippingCountry: billingAddress.shippingCountry || "",
        shippingStateCode: "",
    };
};


export const calculateInvoiceAmount = ({ quantity, price, discount, tax }) => {
    const qty = parseFloat(quantity) || 0;
    const unitPrice = parseFloat(price) || 0;
    const discountRate = parseFloat(discount) || 0;
    const taxRate = parseFloat(tax) || 0;

    const totalPrice = qty * unitPrice;
    const discountAmount = (discountRate / 100) * totalPrice;
    const discountedPrice = totalPrice - discountAmount;
    const taxAmount = (taxRate / 100) * discountedPrice;

    return (discountedPrice + taxAmount).toFixed(2);
};

export const calculateInvoiceTotals = (data) => {
    let subTotal = 0;
    let totalDiscount = 0;
    let totalTax = 0;
    let tcs = 0;
    let roundOff = 0;

    data.forEach(item => {
        const itemPrice = parseFloat(item.price) || 0;
        const itemQty = parseFloat(item.quantity) || 0;
        const discountRate = parseFloat(item.discount) || 0;
        const itemTax = parseFloat(item.tax) || 0;

        const itemTotal = itemPrice * itemQty;
        const discountAmount = (discountRate / 100) * itemTotal;
        subTotal += itemTotal;
        totalDiscount += discountAmount;
        totalTax += ((itemTotal - discountAmount) * itemTax) / 100;
    });

    const totalBeforeTax = subTotal - totalDiscount;
    const total = totalBeforeTax + totalTax;

    return {
        subTotal: `${subTotal.toFixed(2)}`,
        totalDiscount: `${totalDiscount.toFixed(2)}`,
        beforeTax: `${totalBeforeTax.toFixed(2)}`,
        tax: `${totalTax.toFixed(2)}`,
        tcs: `${tcs.toFixed(2)}`,
        roundOff: roundOff,
        total: `${total.toFixed(2)}`
    };
};

export const calculateInvoiceTotalsWithGST = (data, userState, billingState) => {
    let subTotal = 0;
    let totalDiscount = 0;
    let totalIGST = 0;
    let totalCGST = 0;
    let totalSGST = 0;
    let tcs = 0;

    data.forEach(item => {
        const itemPrice = parseFloat(item.price) || 0;
        const itemQty = parseFloat(item.quantity) || 0;
        const discountRate = parseFloat(item.discount) || 0;
        const igstRate = parseFloat(item.igst) || 0;
        const cgstRate = parseFloat(item.cgst) || 0;
        const sgstRate = parseFloat(item.sgst) || 0;

        const itemTotal = itemPrice * itemQty;
        const discountAmount = (discountRate / 100) * itemTotal;

        subTotal += itemTotal;
        totalDiscount += discountAmount;

        const taxableAmount = itemTotal - discountAmount;

        if (userState === billingState) {
            totalCGST += (taxableAmount * cgstRate) / 100;
            totalSGST += (taxableAmount * sgstRate) / 100;
        } else {
            totalIGST += (taxableAmount * igstRate) / 100;
        }
    });

    const totalBeforeTax = subTotal - totalDiscount;
    const tax = totalIGST + totalCGST + totalSGST;
    const total = totalBeforeTax + tax;
    
    console.log("totalBeforeTax, totalIGST, totalCGST, totalSGST, tax, total", totalBeforeTax, totalIGST, totalCGST, totalSGST, tax, total);
    return {
        subTotal: `${subTotal.toFixed(2)}`,
        totalDiscount: `${totalDiscount.toFixed(2)}`,
        beforeTax: `${totalBeforeTax.toFixed(2)}`,
        igst: `${totalIGST.toFixed(2)}`,
        cgst: `${totalCGST.toFixed(2)}`,
        sgst: `${totalSGST.toFixed(2)}`,
        tcs: `${tcs.toFixed(2)}`,
        total: `${total.toFixed(2)}`,
        tax:`${tax.toFixed(2)}`,
    };
};

export const convertNumberToWords = (amount) => {
    const words = [
        "Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
        "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
        "Seventeen", "Eighteen", "Nineteen",
    ];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const scales = ["", "Thousand", "Million", "Billion"];

    if (amount === 0) return "Zero Rupees";

    const convertToWords = (num) => {
        if (num < 20) return words[num];
        if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ` ${words[num % 10]}` : "");
        if (num < 1000) return `${words[Math.floor(num / 100)]} Hundred${num % 100 !== 0 ? ` ${convertToWords(num % 100)}` : ""}`;
        for (let i = 0; i < scales.length; i++) {
            const unit = 1000 ** (i + 1);
            if (num < unit) {
                return `${convertToWords(Math.floor(num / (1000 ** i)))} ${scales[i]}${num % (1000 ** i) !== 0 ? ` ${convertToWords(num % (1000 ** i))}` : ""}`;
            }
        }
    };

    return `${convertToWords(amount)} Rupees`;
};

export const formatPuchaseOrder = (formData, tableData, color) => {
    return {
        itemId: tableData.productId,
        suppiler: formData.supplier,
        order_no: formData.orderNo,
        size: formData.size,
        fabricator: formData.fabricator,
        style_no: formData.styleNo,
        style_name: formData.styleName,
        remarks: formData.remarks,
        dated: formData.dated,
        delivery_date: formData.deliveryDate,
        delivery_at: formData.deliveryAt,
        color,
        issue_quantity: formData.issueQuantity,
        total: tableData.item.reduce((sum, item) => sum + item.total, 0),
    };
};

export const formatPuchaseEditOrder = (formData, tableData) => {
    return {
        itemId: tableData.productId,
        suppiler: formData.supplier,
        size: formData.size,
        fabricator: formData.fabricator,
        style_no: formData.styleNo,
        style_name: formData.styleName,
        remarks: formData.remarks,
        dated: formData.dated,
        delivery_date: formData.deliveryDate,
        delivery_at: formData.deliveryAt,
        issue_quantity: formData.issueQuantity,
        total: tableData.item.reduce((sum, item) => sum + item.total, 0),
        color: formData.color
    };
};


export const options = [
    {
        label: 'Red',
        value: 'red',
        desc: 'Red ',
    },
    {
        label: 'Blue',
        value: 'blue',

        desc: 'Blue',
    },
    {
        label: 'Green',
        value: 'green',
        desc: 'Green ',
    },
    {
        label: 'Yellow',
        value: 'yellow',
        desc: 'Yellow ',
    },
    {
        label: 'Orange',
        value: 'orange',
        desc: 'Orange ',
    },
    {
        label: 'Purple',
        value: 'purple',
        desc: 'Purple',
    },
    {
        label: 'Black',
        value: 'black',
        desc: 'Black',
    },
    {
        label: 'White',
        value: 'white',
        desc: 'White',
    },
    {
        label: 'Brown',
        value: 'brown',
        desc: 'Brown',
    },
];


export const formatCurrency = (value) =>
    new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
    }).format(value || 0);